import { KONAMI_TOGGLED, CODE_TOGGLED } from './actionTypes';

export const toggleKonamiMode = () => ({
  type: KONAMI_TOGGLED,
});

export const toggleCodeMode = () => ({
  type: CODE_TOGGLED,
});

// Action Creators

export function toggleKonami() {
  // console.log('konami');
  return dispatch => {
    dispatch(toggleKonamiMode());
  };
}

export function toggleCode() {
  // console.log('code');
  return dispatch => {
    dispatch(toggleCodeMode());
  };
}



// WEBPACK FOOTER //
// ./src/actions/shortcuts.js